<ng-container *transloco="let t; prefix: 'organizations.detailPage.riskAnalysisDeliveryTab.documents'">
  <div class="b-tracker-documents__header">
    <h3 class="b-tracker-documents__title">{{ t('title') }}</h3>

    <aml-button
      [variant]="ButtonVariantMap.primary"
      [icon]="IconNameMap.upload"
      [disabled]="isDelivering()"
      (buttonClicked)="openResultUploadDialog()"
    >
      {{ t('uploadButton') }}
    </aml-button>
  </div>

  @if (!isLoading() && documents().length === 0) {
    <p class="b-tracker-documents__empty">{{ t('empty') }}</p>
  } @else {
    <aml-datatable
      [dataSource]="documents()"
      [columns]="tableColumns"
      [hasMore]="false"
      [isLoading]="isLoading()"
      [showToolbar]="false"
    />
  }
</ng-container>
